import {Component, OnInit} from '@angular/core';
import {GrCompany, GrPagination, GrUser} from '../../../interfaces/general-interfaces';
import {UserRole} from '../../../enums/general-enums';
import {ToastrService} from 'ngx-toastr';
import {UsersHttpService} from '../../../services/http-services/users/users-http.service';
import {GetBusinessUsersApiDataFormatted} from '../../../services/http-services/users/users-http-interfaces';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {ActivatedRoute} from '@angular/router';
import {BusinessProfilesHttpService} from '../../../services/http-services/business-profiles/business-profiles-http.service';

@Component({
  selector: 'gr-business-list',
  templateUrl: './business-list.component.html',
})
export class BusinessListComponent implements OnInit {
  businessUsersList: GrCompany[] = [];
  businessUserForEdit: GrUser | null = null;
  businessUserForDelete: GrCompany | null = null;
  businessUsersPagination: GrPagination | undefined;
  activeUsers: number | undefined = 0;
  inactiveUsers: number | undefined = 0;
  urlParams: any = {page: 1, role: UserRole.business, search: null, business_category: 1, sort: null, direction: null};
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;
  categoryId: any;
  columnSelected = 'name';

  constructor(private usersHttpService: UsersHttpService,
              private businessProfilesHttpService: BusinessProfilesHttpService,
              private activatedRoute: ActivatedRoute,
              private toastService: ToastrService) {
  }
  ngOnInit(): void {
    this.activatedRoute.params.subscribe(res => {
      this.categoryId = res.categoryId;

      if (!this.categoryId) return;

      if (this.categoryId === 'new') {
        this.urlParams.business_category = null;
        this.getNewBusinessUsers();
      }
      else if (this.categoryId === 'all') {
        this.urlParams.column = this.columnSelected;
        this.urlParams.business_category = null;
        this.getAllBusinessUsers();
      }
      else if (this.categoryId === 'inactive') {
        this.getAllInactiveUsers();
      }
      else {
        this.urlParams.business_category = this.categoryId;
        this.getBusinessUsers();
      }
    });
  }

  getBusinessUsers(): void {
    this.urlParams.page = (this.businessUsersPagination?.currentPage) ? this.businessUsersPagination.currentPage : 1;
    this.usersHttpService.getBusinessUsers(this.urlParams).then((res: GetBusinessUsersApiDataFormatted) => {
      this.activeUsers = res.active;
      this.inactiveUsers = res.inactive;
      this.businessUsersList = res.data;
      this.businessUsersPagination = res.pagination;
    });
  }

  getNewBusinessUsers(): void {
    this.urlParams.page = (this.businessUsersPagination?.currentPage) ? this.businessUsersPagination.currentPage : 1;
    this.businessProfilesHttpService.getUncategorizedBusinessesAll(this.urlParams).then((res: GetBusinessUsersApiDataFormatted) => {
      this.businessUsersList = res.data;
      this.businessUsersPagination = res.pagination;
    });
  }

  getAllBusinessUsers(): void {
    this.urlParams.page = (this.businessUsersPagination?.currentPage) ? this.businessUsersPagination.currentPage : 1;
    this.businessProfilesHttpService.getAllBusinessesAll(this.urlParams).then((res: GetBusinessUsersApiDataFormatted) => {
      this.businessUsersList = res.data;
      this.businessUsersPagination = res.pagination;
    });
  }

  getAllInactiveUsers(): void {
    this.urlParams.page = (this.businessUsersPagination?.currentPage) ? this.businessUsersPagination.currentPage : 1;
    this.businessProfilesHttpService.getAllInactiveBusinesses(this.urlParams).then((res: GetBusinessUsersApiDataFormatted) => {
      console.log('res', res.pagination)
      this.businessUsersList = res.data;
      this.activeUsers = res.pagination.totalItems;
      this.businessUsersPagination = res.pagination;
    });
  }

  onSearchChange(searchQuery: string): void {
    this.urlParams.search = searchQuery;
    this.businessUsersPagination = undefined;

    if (this.categoryId === 'new') {
      this.getNewBusinessUsers();
    }
    else if (this.categoryId === 'all') {
      this.getAllBusinessUsers();
    }
    else {
      this.getBusinessUsers();
    }
  }

  onPageChanged(page: any): void {
    if (this.businessUsersPagination) {
      this.businessUsersPagination.currentPage = page;
      if (this.categoryId === 'new') {
        this.getNewBusinessUsers();
      }
      else if (this.categoryId === 'all') {
        this.getAllBusinessUsers();
      }
      else {
        this.getBusinessUsers();
      }
    }
  }

  onSortChange(type: string): void {
    if (this.urlParams.sort === type) {
      this.urlParams.direction === 'asc' ? this.urlParams.direction = 'desc' : this.urlParams.direction = 'asc';
    } else {
      this.urlParams.sort = type;
      this.urlParams.direction = 'asc';
    }
    if (this.categoryId === 'new') {
      this.getNewBusinessUsers();
    }
    else if (this.categoryId === 'all') {
      this.getAllBusinessUsers();
    }
    else {
      this.getBusinessUsers();
    }
  }

  onConfirmEditBusinessUser(): void {
    this.businessUserForEdit = null;
    this.urlParams.business_category
      ? this.getBusinessUsers()
      : this.getNewBusinessUsers();
  }

  removeBusinessUser(businessUserId: number | null): void {
    if (businessUserId) {
      this.usersHttpService.deleteUser({userId: businessUserId}).then(res => {
        this.urlParams.business_category
          ? this.getBusinessUsers()
          : this.getNewBusinessUsers();
        this.businessUserForDelete = null;
        this.toastService.success('Uspešno ste obrisali biznis korisnika.');
      }, error => {
        this.toastService.warning('Došlo je do greške, pokušajte ponovo.');
      });
    }
  }

  onColumnSelected(event: any) {
    this.columnSelected = event.prop;
    this.urlParams.column = this.columnSelected;
  }
}
